import React, { useEffect, useState } from 'react';
import { settingsApi } from '../api/client';

interface LogoProps {
  className?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  showCompanyName?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'medium', showCompanyName = false }) => {
  const [logoData, setLogoData] = useState<string | null>(null);
  const [companyName, setCompanyName] = useState<string>('Star London');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLogo = async () => {
      try {
        const settings = await settingsApi.getPublicSettings();
        if (settings.logo_data && settings.logo_content_type) {
          setLogoData(`data:${settings.logo_content_type};base64,${settings.logo_data}`);
        }
        if (settings.company_name) {
          setCompanyName(settings.company_name);
        }
      } catch (error) {
        console.error('Failed to load logo:', error);
      } finally {
        setLoading(false);
      }
    };

    loadLogo();
  }, []);

  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'max-h-8 max-w-24';
      case 'large':
        return 'max-h-16 max-w-48';
      case 'xlarge':
        return 'h-14 max-h-14 max-w-64';
      case 'medium':
      default:
        return 'max-h-10 max-w-32';
    }
  };

  if (loading) {
    return (
      <div className={`flex items-center ${className}`}>
        <div className={`${getSizeClasses()} bg-gray-200 animate-pulse rounded aspect-[3/1]`} />
      </div>
    );
  }

  return (
    <div className={`flex items-center ${className}`}>
      {logoData ? (
        <img
          src={logoData}
          alt={`${companyName} Logo`}
          className={`${getSizeClasses()} object-contain`}
        />
      ) : (
        <div className="flex items-center">
          <span className="text-xl font-bold text-gray-900">{companyName}</span>
        </div>
      )}
      {showCompanyName && logoData && (
        <span className="ml-3 text-lg font-semibold text-gray-900">{companyName}</span>
      )}
    </div>
  );
};

export default Logo;